/* eslint-disable multiline-ternary */
import React, { useState } from 'react';
import {
    Stepper,
    Paper,
    Step,
    StepLabel,
    Button,
    Typography,
    CircularProgress
} from '@material-ui/core';
import { Formik, Form } from 'formik';

import moment from 'moment'
import ApplicationDetails from './Forms/ApplicationDetails';
import AdditionalInformation from './Forms/AdditionalInformation';
import ReviewApplication from './Forms/ReviewApplication';
import ApplicationResult from './Forms/ApplicationResult';
import ApplicationDeleted from './Forms/ApplicationDeleted';

import validationSchema from './FormModels/formValidation';
import formModel from './FormModels/formModels';
import initialValues from './FormModels/formInitial'

import useStyles from '../styles';
import dataStorage from '@s/dataStorage';
import {
    createDraftOtherApplicant,
    saveDraft,
    clone,
    getMobilePhoneValue,
    isMyApplicant,
    getAddressData,
    mapDataAddress,
    mapManualAddress,
    checkSubmitted,
    getEnv,
    isBroker,
    checkKycVerify,
    isOtherApplicant,
    isMorrison,
    scrollToTop
} from '@s/helper/utils';
import {
    getSessionUrl,
    getAuthUrl,
    getRefreshUrl,
    getOpeningAccountUrl,
    getBusinessInfoUrl,
    getPerformSearchUrl
} from '@s/api/index'
import { postData } from '@s/api/request'
import at from 'lodash/at'
import {
    BANK_ACCOUNT_TYPE,
    CMT_PROVIDER,
    TRANSACTION_TYPE,
    GOVERNMENT_ID_TYPE,
    CMA,
    OCCUPATION_TYPE,
    SETTLEMENT_METHOD,
    MEDICARE_CARD_COLOUR,
    ACCOUNT_STATUS,
    ACCOUNT_STATUS_DISPLAY
} from '@Common/constants'
import { v4 as uuidv4 } from 'uuid';
import DeleteApplicationButton from '@Components/DeleteApplicationButton'
import FocusError from '@Components/FocusError'
import CryptoJS from 'react-native-crypto-js';

const { formId, formField } = formModel;

const checkShow = (listDepend, formValues) => {
    if (typeof listDepend === 'object' && Object.keys(listDepend).length) {
        const keys = Object.keys(listDepend)
        for (let index = 0; index < keys.length; index++) {
            const depend = at(formValues, keys[index])[0] ?? {}
            const value = depend.value || depend
            if (value !== listDepend[keys[index]]) return false
        }
    }
    return true
}
export default function Joint(props) {
    const { data = {} } = dataStorage.dicDraft;
    let { formData = {}, step = 0, indexApplicant = 0 } = data;
    const steps = isOtherApplicant() ? ['Application Details', 'Review'] : ['Application Details', 'Additional Information', 'Review'];
    const validateObj = isOtherApplicant() ? [validationSchema[0], validationSchema[3]] : validationSchema;
    if (dataStorage.accountStatus && dataStorage.accountStatus !== ACCOUNT_STATUS.IN_KYC) step = steps.length - 1
    if (indexApplicant) dataStorage.indexApplicant = indexApplicant
    if (formData.equixId) dataStorage.equixId = formData.equixId
    const classes = useStyles();

    const [activeStep, setActiveStep] = useState(step);
    const currentValidationSchema = validateObj[activeStep];
    const isLastStep = activeStep === steps.length - 1;
    const refNext = React.useRef(null)
    const listStepCanPress = React.useRef({ 0: true, 1: step > 0, 2: step > 1, 3: step > 2 })
    const initialData = React.useRef({ ...initialValues, ...formData });
    if (!dataStorage.equixId && dataStorage.registerEmail) {
        initialData.current.applicant_details[0].applicant_email = dataStorage.registerEmail
    }
    const applicantDetailRef = React.useRef()
    function _renderStepContent(values) {
        if (isOtherApplicant()) {
            switch (activeStep) {
                case 0:
                    return <ApplicationDetails ref={applicantDetailRef} onNext={onNext} />;
                case 1:
                    return <ReviewApplication />;
                default:
                    return <div>Not Found</div>;
            }
        } else {
            switch (activeStep) {
                case 0:
                    return <ApplicationDetails ref={applicantDetailRef} onNext={onNext} />;
                case 1:
                    return <AdditionalInformation />;
                case 2:
                    return <ReviewApplication />;
                default:
                    return <div>Not Found</div>;
            }
        }
    }

    const clearTrashFieldAndMapData = (obj = {}, path = '', formValues) => {
        try {
            Object.keys(obj).forEach(field => {
                const pathField = `${path ? path + '.' : ''}${field}`
                let item = obj[field]
                if (![undefined, null, ''].includes(item)) {
                    if (Array.isArray(item)) {
                        item.forEach((e, i) => {
                            clearTrashFieldAndMapData(e, `${pathField}[${i}]`, e)
                        })
                    } else {
                        if (typeof item === 'object' && Object.keys(item).length && (!Object.prototype.hasOwnProperty.call(item, 'label') && !Object.prototype.hasOwnProperty.call(item, 'value') && !Object.prototype.hasOwnProperty.call(item, 'full_address'))) return clearTrashFieldAndMapData(item, pathField, formValues)
                        if (typeof item === 'object' && Object.keys(item).length && Object.prototype.hasOwnProperty.call(item, 'label') && Object.prototype.hasOwnProperty.call(item, 'value')) {
                            item = item.value
                            obj[field] = item
                        }
                        const fieldModel = at(formField, pathField.replace(/\[\d]/, ''))[0] ?? {}
                        if (fieldModel && fieldModel.dependentShow) {
                            if (!checkShow(fieldModel.dependentShow, formValues)) {
                                delete obj[field]
                            }
                        }
                    }
                } else delete obj[field]
            })
        } catch (error) {
            console.error('clearTrashFieldAndMapData error ', error)
        }
    }

    async function _submitForm(values, actions) {
        if (isOtherApplicant()) {
            const url = getOpeningAccountUrl(`/joint/agreement/${dataStorage?.equixId}`)
            const applicant = values.applicant_details[dataStorage.activeIndex]
            // eslint-disable-next-line camelcase
            const { client_address, applicant_id, total_confirm, macquarie_confirm, quant_edge_privacy_statement_confirm, morrison_confirm, terms_confirm } = applicant
            const checkTerms = isMorrison() ? terms_confirm : (terms_confirm && morrison_confirm) // eslint-disable-line
            // eslint-disable-next-line camelcase
            if (client_address && total_confirm && macquarie_confirm && quant_edge_privacy_statement_confirm && checkTerms) {
                const params = {
                    applicant_id,
                    // eslint-disable-next-line camelcase
                    applicant_agreement: true
                }
                // debugger;//eslint-disable-line
                // console.log(values);
                postData(url, params).then(response => {
                    // console.log(response);
                    window.onbeforeunload = null; // remove popup close tab
                    dataStorage.applicantInfo = response || { ...values }
                    response?.all_application_submitted && (dataStorage.all_application_submitted = response?.all_application_submitted)
                    actions.setSubmitting(false);
                    let id
                    if (dataStorage.listDraft.length === 1 && dataStorage.userType === 0) {
                        id = dataStorage.listDraft[0]?.id
                    } else {
                        id = dataStorage.dicDraft?.id
                    }
                    values.applicant_details[dataStorage.indexApplicant].applicant_agreement = true
                    saveDraft({
                        formData: {
                            ...values,
                            equix_id: dataStorage.equixId,
                            submit_time: +new Date(),
                            tos_ip: window.ipPublic,
                            tos_user_agent: navigator.userAgent
                        },
                        step: activeStep,
                        id,
                        indexApplicant: dataStorage.indexApplicant,
                        index: dataStorage.activeIndex
                    })
                    setActiveStep(activeStep + 1);
                })
                    .catch(error => {
                        console.log('submit opening account error: ', error)
                        dataStorage.showError && dataStorage.showError(error)
                        actions.setSubmitting(false);
                    })
            }
            // postData(url)
            // console.log(values)
            return
        }
        const sessionId = +new Date()
        const sessionUrl = getSessionUrl(sessionId);
        const { data: getSessonUrl } = await postData(sessionUrl);
        const obj = clone(values)
        const getHashPassword = CryptoJS.AES.encrypt(obj.password, getSessonUrl.key).toString();
        obj.password = getHashPassword;
        obj.session_id = sessionId + '';
        delete obj.confirmPassword
        clearTrashFieldAndMapData(obj, '', values)

        // get user agent info for compliance
        obj.tos_ip = window.ipPublic;
        obj.tos_user_agent = navigator.userAgent
        // console.log(values, 'test1')
        // handler applicant details
        // eslint-disable-next-line no-debugger
        // debugger;
        obj.trade_confirmations.length = obj.applicant_details.length
        const listAddressId = obj.applicant_details.reduce((acc, cur) => {
            if (!cur.manual_address && cur.residential_address_full_address?.id) {
                acc.push(cur.residential_address_full_address?.id)
            }
            if (cur.occupation_type === OCCUPATION_TYPE[getEnv()].BUSINESS_OWNER && cur.business_owner_trading_address_full_address?.id) {
                acc.push(cur.business_owner_trading_address_full_address?.id)
            }
            return acc
        }, [])
        if (listAddressId.length) {
            await getAddressData(listAddressId)
        }
        const otherData = []
        obj.applicant_details.forEach((e, i) => {
            if (!e.applicant_id) e.applicant_id = uuidv4()
            // e.applicant_id = uuidv4()
            // trade_confirmations
            e.applicant_email = e.applicant_email?.trim()
            if (!obj.trade_confirmations[i]) obj.trade_confirmations[i] = {}
            obj.trade_confirmations[i].method = 'EMAIL';
            obj.trade_confirmations[i].email = e?.applicant_email;
            obj.trade_confirmations[i].client_address = isBroker() ? true : e.client_address;
            delete e.client_address
            delete e.ekyc_aml_consent
            delete e.total_confirm
            delete e.morrison_confirm
            delete e.terms_confirm
            delete e.quant_edge_privacy_statement_confirm
            delete e.macquarie_confirm
            delete e.financial_services_guide_confirm
            delete e.verification_id
            delete e.ekyc_overall_status

            if (!i) {
                dataStorage.applicantId = e.applicant_id
                if (e.government_id.type === GOVERNMENT_ID_TYPE.MEDICARE_CARD) {
                    e.government_id.medicare_name_on_card = e.first_name + ' ' + e.last_name;
                    const expireDate = e.government_id.medicare_card_expiry_date
                    if (e.government_id.medicare_card_colour === MEDICARE_CARD_COLOUR.GREEN) {
                        e.government_id.medicare_card_expiry_date = moment(expireDate, moment.ISO_8601).format('MM/YYYY')
                    } else {
                        e.government_id.medicare_card_expiry_date = moment(expireDate, moment.ISO_8601).format('DD/MM/YY')
                    }
                } else {
                    e.government_id.first_name = e.first_name;
                    e.government_id.last_name = e.last_name;
                }
                e.government_id = [e.government_id]
                // e.applicant_id=
            } else {
                otherData.push(values.applicant_details[i])
                delete e.government_id
                delete e.australian_tax_resident
            }

            // handle address
            if (e.manual_address) {
                mapManualAddress(e, e)
            } else {
                mapDataAddress(e, e.residential_address_full_address?.id, e.same_as_ra, 'residential_address')
            }
            if (e.occupation_type === OCCUPATION_TYPE[getEnv()].BUSINESS_OWNER) {
                mapDataAddress(e, e.business_owner_trading_address_full_address?.id, false, 'business_owner_trading_address')
            }
            delete e.manual_address
            if (i !== 0 && !isBroker()) {
                delete e.same_as_ra
                delete e.nationality
                return
            }
            e.same_as_ra = true;
            e.relationship_type = 'OWNER';
            e.residential_address_country = 'AUSTRALIA'
            e.country_of_birth = 'AUSTRALIA'
            // eslint-disable-next-line no-unused-expressions
            e.applicant_mobile_phone ? (e.applicant_mobile_phone = getMobilePhoneValue(e.applicant_mobile_phone)) : ''
            e.dob = moment(e.dob, moment.ISO_8601).format('DD/MM/YYYY')
            // delete e.same_as_ra
            // delete e.relationship_type
            // delete e.residential_address_country
            // delete e.country_of_birth
            // delete e.dob
            // delete e.nationality
        })

        // new cma account and settlement_method
        obj.new_cma = !obj.use_existing_CMT_acc
        obj.settlement_method = obj.settlement_method ? SETTLEMENT_METHOD.SPONSORED_HIN_TRANSFER : SETTLEMENT_METHOD.SPONSORED_NEW_HIN
        obj.settlement_existing_hin && (obj.settlement_existing_hin = +obj.settlement_existing_hin)
        if (obj.new_cma) {
            obj.new_cma = CMA.CREATE_NEW
            obj.bank_account_type = BANK_ACCOUNT_TYPE.BANK_ACCOUNT;
            obj.bank_cmt_provider = CMT_PROVIDER.MBLA;
        } else {
            obj.new_cma = CMA.USE_EXISTING
            obj.bank_account_type = BANK_ACCOUNT_TYPE.LINKED_CMT_CMA;
            obj.bank_cmt_provider = CMT_PROVIDER.MBLA;
        }
        obj.bank_transaction_type = TRANSACTION_TYPE.BOTH

        // delete other fields
        delete obj.use_existing_CMT_acc
        delete obj.equixId

        // link draft id with submit object
        dataStorage.dicDraft.id && (obj.draft_id = dataStorage.dicDraft.id)
        // debugger;//eslint-disable-line
        const url = getOpeningAccountUrl(`/joint/${dataStorage.equixId}`)
        delete obj.equix_id
        delete obj.submit_time
        // delete obj.same_as_ra
        // delete obj.relationship_type
        // delete obj.residential_address_country
        // delete obj.country_of_birth
        // delete obj.nationality
        postData(url, obj).then((res) => {
            window.onbeforeunload = null; // remove popup close tab
            // console.log(res, 'test1')
            dataStorage.applicantInfo = res || { ...dataStorage.applicantInfo, ...values }
            actions.setSubmitting(false);
            setActiveStep(activeStep + 1);
            let id
            if (dataStorage.listDraft.length === 1 && dataStorage.userType === 0) {
                id = dataStorage.listDraft[0]?.id
            } else {
                id = dataStorage.dicDraft?.id
            }
            saveDraft({
                formData: {
                    ...values,
                    equix_id: dataStorage.equixId,
                    submit_time: +new Date(),
                    tos_ip: obj.tos_ip,
                    tos_user_agent: obj.tos_user_agent
                },
                step: activeStep,
                index: 0,
                indexApplicant: dataStorage.indexApplicant,
                id
            })
            if (!isBroker()) {
                const otherApplicantsPromise = []
                otherData.forEach((e, i) => {
                    otherApplicantsPromise.push(createDraftOtherApplicant(dataStorage.equixId, e.applicant_id, e.applicant_email, {
                        formData: {
                            ...values,
                            equix_id: dataStorage.equixId,
                            tos_ip: obj.tos_ip,
                            tos_user_agent: obj.tos_user_agent
                        },
                        step: 0,
                        indexApplicant: i + 1,
                        index: i + 1
                    }))
                })
                Promise.all(otherApplicantsPromise).then(res => {
                    console.log('YOLO')
                }).catch(err => {
                    console.log('YOLO err', err)
                })
            }
        }).catch(error => {
            console.log('submit opening account error: ', error)
            dataStorage.showError && dataStorage.showError(error)
            actions.setSubmitting(false);
        })
    }

    const onDelete = () => {
        setActiveStep(-1)
    }

    const onNext = (values, actions) => {
        scrollToTop();
        let id
        if (dataStorage.listDraft.length === 1 && dataStorage.userType === 0) {
            id = dataStorage.listDraft[0]?.id
        } else {
            id = dataStorage.dicDraft?.id
        }
        listStepCanPress.current[activeStep + 1] = true
        saveDraft({
            formData: {
                ...values,
                equix_id: dataStorage.equixId
            },
            step: activeStep + 1,
            index: dataStorage.activeIndex,
            indexApplicant: dataStorage.indexApplicant,
            id
        })
        actions.setTouched({});
        actions.setSubmitting(false);
        setActiveStep(activeStep + 1);
    }

    const onStepClick = (index) => {
        if (listStepCanPress.current[index]) {
            setActiveStep(index)
        } else {
            if (index < activeStep) {
                _handleBack()
            } else if (index > activeStep) {
                refNext.current && refNext.current.click()
            }
        }
    }

    function _handleSubmit(values, actions) {
        if (isLastStep) {
            _submitForm(values, actions);
        } else {
            onNext(values, actions)
        }
    }

    function _backChooseDraft() {
        props.backChooseDraft && props.backChooseDraft()
    }

    function _handleBack(setFieldValue) {
        const func = () => {
            if (activeStep === 0) {
                props.backChooseAccountType && props.backChooseAccountType()
            } else {
                scrollToTop()
                setActiveStep(activeStep - 1);
            }
        }
        if (activeStep !== 0) {
            func()
        } else {
            applicantDetailRef.current && applicantDetailRef.current.checkBack(func)
        }
    }

    const renderBackDraftButton = () => {
        if ((dataStorage.listDraft.length < 2 && !isBroker()) || dataStorage.isOperatorSupport) return <React.Fragment />
        return (
            <div className={classes.wrapper} align="left">
                <Button
                    onClick={_backChooseDraft}
                    variant="contained"
                    className={classes.button}
                >
                    {'Back To Draft List'}
                </Button>
            </div>
        )
    }

    const checkCanSubmit = (values) => {
        let check = true
        const checkIndex = isBroker() ? 0 : (dataStorage.isSubApplicant ? dataStorage.activeIndex : 0)
        const element = values.applicant_details[checkIndex];
        const checkTerms = isMorrison() ? !element.terms_confirm : (!element.terms_confirm || !element.morrison_confirm)
        if (!element.client_address || !element.total_confirm || !element.macquarie_confirm || !element.quant_edge_privacy_statement_confirm || checkTerms) {
            check = false
        }
        return !isLastStep || check
    }

    const renderButtons = (isSubmitting, values, actions) => {
        const checkCondition = activeStep === 0 && isMyApplicant(dataStorage.indexApplicant) && !checkKycVerify(values.applicant_details[dataStorage.indexApplicant].ekyc_overall_status)
        const accountType = dataStorage.accountType
        if (!accountType) return <React.Fragment />
        if (checkSubmitted()) {
            return (<div className={classes.buttons}>
                <div className={classes.leftButtons}>
                    {renderBackDraftButton()}
                    <div style={{ width: 8 }} />
                    <DeleteApplicationButton onDelete={onDelete} />
                </div>
            </div>)
        }
        const isCheckAML = values.applicant_details[dataStorage.indexApplicant]?.ekyc_aml_consent;
        const isAccepted = checkCondition ? isCheckAML : checkCanSubmit(values);
        const textSubmit = isLastStep ? 'Submit Application' : (checkCondition ? 'confirm' : 'next');
        return (
            <div className={classes.buttons}>

                {/* Back to Draft Button is on left handside */}
                <div className={classes.leftButtons}>
                    {renderBackDraftButton()}
                    <div style={{ width: 8 }} />
                    <DeleteApplicationButton onDelete={onDelete} />
                </div>
                <div className={classes.rightButtons}>
                    {accountType && (
                        <div className={classes.wrapper}>
                            <Button onClick={() => _handleBack(actions.setFieldValue)} className={classes.button}>
                                Back
                            </Button>
                        </div>
                    )}
                    <div className={classes.wrapper}>
                        <Button
                            ref={refNext}
                            disabled={isSubmitting || !isAccepted}
                            onClick={() => {
                                if (activeStep === 0) actions.setSubmitting(true)
                                else actions.submitForm()
                            }}
                            variant="contained"
                            color="primary"
                            className={classes.button}
                        >
                            {textSubmit}
                            {isSubmitting && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <React.Fragment>
            <Paper className={classes.paper} elevation={15} >

                {
                    activeStep === -1
                        ? <ApplicationDeleted backChooseDraft={_backChooseDraft} />
                        : (
                            activeStep === steps.length
                                ? <ApplicationResult backChooseDraft={_backChooseDraft} />
                                : (
                                    <React.Fragment>
                                        <Typography id='topJoint' component="h1" variant="h6" align="center">
                                            {dataStorage.accountStatus ? (ACCOUNT_STATUS_DISPLAY[dataStorage.accountStatus] || dataStorage.accountStatus) : 'NEW TRADING ACCOUNT'}
                                        </Typography>
                                        {/* navigation */}
                                        <div className={classes.container}>
                                            <Stepper
                                                orientation='vertical'
                                                activeStep={activeStep} className={classes.stepperVertical}>
                                                {steps.map((label, i) => (
                                                    <Step key={label} onClick={() => onStepClick(i)} className={listStepCanPress.current[i] ? 'stepActive' : ''}>
                                                        <StepLabel>{label}</StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                            <Stepper
                                                activeStep={activeStep} className={classes.stepperHorizontal}>
                                                {steps.map((label, i) => (
                                                    <Step key={label} onClick={() => onStepClick(i)} className={listStepCanPress.current[i] ? 'stepActive' : ''}>
                                                        <StepLabel>{label}</StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                            <div className={classes.formContainer}>
                                                <Formik
                                                    initialValues={initialData.current}
                                                    validationSchema={currentValidationSchema}
                                                    validateOnBlur={true}
                                                    validateOnChange={false}
                                                    onSubmit={_handleSubmit}
                                                >
                                                    {({ isSubmitting, setFieldValue, errors, values, setFieldTouched, validateField, submitForm, setSubmitting, validateForm }) => (
                                                        <FocusError>
                                                            <Form id={formId} autoComplete='off'>
                                                                {_renderStepContent(values)}
                                                                {renderButtons(isSubmitting, values, { setFieldValue, submitForm, setSubmitting, validateForm })}
                                                            </Form>
                                                        </FocusError>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
            </Paper>
        </React.Fragment>
    );
}
